import { Input  } from 'antd';

const { Search } = Input

export const SearchInput = ({...props}) => {
  return <Search {...props} />;
};
